// tslint:disable: max-line-length
export const sv = {
    admin: {
        user: 'Display för kundläge',
        userModeDescription:
            'Genom att aktivera detta läge kommer sidan att förhandsvises sådan som den presenteras för kunder.',
    },
    app: {
        forvalter: 'Dashbord för fastigheter',
        mittleieforhold: 'Min lokal',
        openInSuperOffice: 'SuperOffice',
        verified: 'Verified',
        d365: 'Dynamics 365',
        eiendomGpt: 'EiendomGPT',
    },
    auth: {
        authorizing: 'Loggar in...',
        loggingOut: 'Loggar ut...',
        login: 'Logga in',
        logout: 'Logga ut',
        // tslint:disable-next-line: max-line-length
        privacyDescription:
            'Genom att använda denna sida samtycker du till att vi samlar in information som används för att förbättra ' +
            'användarupplevelsen för användarna av denna sida. Läs om behandlingen av personuppgifter i Min hyresrätt i vår ',
        privacyLinkTitle: 'sekretesspolicy.',
        sessionTimeout: 'Din session har gått ut',
        sessionTimeoutLoginAgain: 'Logga in igen',
    },
    breadcrumbs: {
        building: 'Fastighet',
        byggUtleie: 'Uthyrning',
        contract: 'Avtal',
        dashboard: 'Min lokal',
        invoice: 'Fakturor',
        listUsers: 'Användare',
        message: 'Anslagstavla',
        registerUser: 'Registrera användare',
        searchUsers: 'Sök efter användare',
        selectClient: 'Välj kundrelation',
        supportApplicationForm: 'Ansökan om stöd',
        ticket: 'Ärenden',
    },
    buildingClientChooser: {
        groupByBuilding: 'Gruppera efter fastighet',
        groupByClient: 'Gruppera efter kund',
        recipients: {
            all: 'Alla mottagare',
            search: 'Sök efter mottagare',
            select: 'Mottagare',
            selected: 'Utvalda mottagare',
        },
    },
    bygg: {
        activeClients: 'Aktiva kunder',
        adresse: 'Adress',
        andelFossilEl: 'Andel fossil/el',
        arealType: 'Typ',
        backToOverview: 'Tillbaka till fastighetsöversikten',
        backToOverviewForClient:
            'Tillbaka till fastighetsöversikten för {{customerName}}',
        beskrivelse: 'Om fastigheten',
        bygg: 'fastighet',
        byggeAar: 'Byggår',
        byggInfo: {
            numberOfBuildings: '{{count}} fastigheter',
            numberOfBuildings_1: '{{count}} fastighet',
            numberOfContracts: '{{count}} avtal',
            numberOfContracts_1: '{{count}} avtal',
        },
        byggListTitle: 'Mina Fastigheter',
        byggListTitleAdmin:
            'fastighet för {{customerName}} ({{customerNumber}})',
        byggListTitleAdminAllBuildings: 'Alla fastigheter',
        byggNummer: 'Husnummer',
        byggSearch: 'Sök Fastighet',
        contractDetails: 'Ekonomi',
        customers: 'Kunder',
        documents: 'Dokument och ritningar',
        driftsAnsvarlig: 'Driftschef',
        driftsTekniker: 'Drifttekniker',
        eiendomsAnsvarlig: 'Fastighetschef',
        eiendomsNummer: 'Fastighetsnummer',
        energiForbruk: 'Beräknad energiförbrukning',
        energiKarakter: 'Energiklass',
        errorList: {
            description: 'Något gick fel vid inläsning av fastigheter.',
            title: 'Något gick fel vid inläsning av fastigheter.',
        },
        errorNoClients: {
            title: 'Inga kunder för denna byggnad.',
        },
        errorNotFound: {
            description: 'Inga fastigheter hittades.',
            title: 'Inga fastigheter hittades.',
        },
        errorSingle: {
            description: 'Något gick fel vid inläsning av fastigheten.',
            title: 'Något gick fel vid inläsning av fastigheten.',
        },
        etasjer: 'Våningar',
        forbruk: 'Miljöprofil',
        futureClients: 'Kommande kunder',
        gabNummer: 'GAB-nummer',
        inactiveClients: 'Inaktiva kunder',
        kompleksNummer: 'Kompleksnummer',
        name: 'Namn',
        overview: 'Översikt',
        searchDocument: {
            placeholder: 'Skriv inn ditt sökord här',
            title: 'Sök i ritningar',
        },
        showAll: 'Visa alla fastigheter',
        tickets: 'Ärenden',
        totAreal: 'Totalarea',
        shortcut: 'Genväg',
    },
    byggCalendar: {
        name: 'Kalender',
        error: {
            title: 'Något gick fel',
            description:
                'Vi har problem med att visa kalendern för den här fastigheten just nu. Försök igen om en stund.',
        },
    },
    byggDokument: {
        errorDownload: {
            description: 'Något gick fel när ritningarna laddades.',
            title: 'Något gick fel när ritningarna laddades.',
        },
        errorNotFound: {
            description:
                'Vi hittade inga dokument eller ritningar relaterade till din byggnad.',
            title: 'Inga ritningar hittades.',
        },
        tableTitle: {
            generalInfo: 'Allmän information',
            contractAttachment: 'Hållbarhet',
            fire: 'Brand',
            escape: 'Flykt',
        },
        etasje: 'Våning',
        maalestokk: 'Skala',
        navn: 'Namn',
        nummer: 'Nummer',
        revdato: 'Revision',
    },
    byggUtleie: {
        areaAvailable: 'Ledigt område',
        areaLeased: 'Hyrt område',
        areaRatio: 'Område uthyrningsgrad',
        areaToExpire: 'Utgående område',
        available: 'Ledig',
        econRatio: 'Ekonomisk uthyrningsgrad',
        expires: 'Går ut',
        expiring: 'Avtal som löper ut',
        leased: 'Uthyrd',
        menu: 'Uthyrning',
        title: 'Fastighetsuthyrning',
        vacant: 'Lediga lokaler pr {{from}}:',
    },
    clientSelect: {
        chooseClient: 'Välj kundrelation',
        clientName: 'Kundnamn',
        clientNumber: 'Kundnummer',
        clientLastActiveInML: 'Senast aktiv i Min lokal',
        errorNoClients: {
            description: 'Kontakta oss för att lösa detta.',
            title: 'Du har inget aktivt kundrelation.',
        },
        errorNoClientsSelected: {
            description:
                'För att se data måste du först välja din kundrelation.',
            title: 'Ingen kundrelation valt',
        },
        notFound: 'Inga kunder hittades.',
        searchClient: 'Sök kund',
        selectAktiveOnly: 'Sök endast i kunder med aktiva avtal',
        selectedClient: 'Vald kund: {{customerName}}',
        welcomeMessageSent: 'Välkomstmeddelande skickat',
    },
    contractManagement: {
        title: 'Avtal',
        leko: 'Förhandlingar',
        avtaler: 'Mina avtal',
    },
    contractFrame: {
        externalFrame: {
            actionButton: 'Öppen avtalsförhandling',
            contractNotFoundDescription:
                'Du hittar alla dina aktuella hyresvillkor under respektive fastighet',
            contractNotFoundLink: 'Gå till mina fastigheter',
            contractNotFoundTitle: 'Letar du efter dina hyresvillkor?',
            manualContractDescription:
                'Du kan få en kopia av dina avtal genom att kontakta din fastighetsförvaltare på KLP',
            manualContractTitle: 'Letar du efter ett existerande PDF-avtal?',
            description:
                'För att öppna avtalsförhandlingen måste vi använda en ny flik',
            title: 'Ska du skriva under eller förhandla om ett nytt avtal?',
        },
    },
    dxboFrame: {
        externalFrame: {
            actionButton: 'Öppna Beslutsportalen',
            description:
                'För att öppna beslutsportalen – där du kan göra anpassningar i dina nya lokaler, behöver vi använda en ny flik',
            title: 'Ska du anpassa ditt nya lokal?',
        },
    },
    leaseAgreement: {
        table: {
            property: 'Fastighet',
            propertyNumber: 'Fastighet Nr.',
            propertyName: 'Fastighet',
            name: 'Namn',
            quantity: 'Area',
            leaseFromDate: 'Från',
            leaseToDate: 'Till',
            contractNumber: 'Avtal Nr.',
            notFound: 'Inga avtal hittades.',
        },
        title: 'Mina avtal',
        activeAgreement: 'Aktiva avtal',
        archivedAgreement: 'Utgågna avtal',
        futureAgreement: 'Framtida avtal',
        errorDownload: {
            description: 'Något gick fel när avtal skulle laddas.',
            title: 'Något gick fel när avtal skulle laddas.',
        },
    },
    environment: {
        // tslint:disable-next-line: max-line-length
        description:
            'Den här tjänsten kan vara instabil under vissa perioder. Vi utvecklar och förbättrar det kontinuerligt och vi uppskattar mycket all din feedback och förslag.',
        dev: 'DEV',
        environment: 'Miljö: ',
        local: 'LOCAL',
        test: 'TEST',
    },
    faktura: {
        amount: 'Belopp',
        betalingsgrad: 'Betalningstakt',
        inkasso: 'Inkasso',
        purring: 'Påminnelse',
        delayed: 'Försenad',
        delayedPayments: 'Försenade betalningar',
        delayedPayments_0: 'Försenad betalning',
        dueDate: 'Förfall',
        errorDownload: {
            description: 'Något gick fel när fakturor laddades.',
            title: 'Något gick fel när fakturor laddades.',
        },
        errorNotFound: {
            description: 'Inga fakturor hittades.',
            title: 'Inga fakturor hittades.',
        },
        emptyTable: 'Inga fakturor matchar din sökning',
        faktura: 'Fakturor',
        faktura_1: 'Faktura',
        fakturaNumber: 'Nr.',
        incomingPayments: 'Kommande betalningar',
        incomingPayments_0: 'Kommande betalning',
        invoiceNumberShort: 'Nr',
        invoicesFor: 'Fakturor för {{kundeName}} ({{kundeNummer}})',
        invoiceSummary: 'Summa {{sum}}kr varav försenat: {{delayed}}kr',
        issueDate: 'Fakturadatum',
        left: 'Utestående',
        lastpaymentdate: 'Senast betalda',
        myInvoices: 'Mina fakturor',
        notSettledInvoices: 'Obetalda fakturor',
        notSettledInvoices_1: 'Obetald faktura',
        paid: 'Betalt',
        payments: 'Betalningar',
        refunds: 'Kreditfakturor',
        refunds_0: 'Kreditfaktura',
        settledInvoice_0: 'Betald faktura',
        settledInvoices: 'Betalda fakturor',
        status: 'Status',
    },
    fakturaStatus: {
        AwaitingPayment: 'Ska betalas',
        AwaitingRefund: 'Ska återbetalas',
        Refunded: 'Återbetalas',
        Paid: 'Betalt',
        PartiallyPayed: 'Delvis betald',
        Overdue: 'Förfallen',
        Unknown: 'Okänd',
    },
    file: {
        deleting: 'Raderar filer ...',
        deleting_1: 'Raderar fil ...',
        downloading: 'Laddar ner...',
        fileNotFound: 'Filen finns inte',
        preview: 'Förhandsvisning',
        previewDownload: 'Förhandsvisning    / Ladda ner',
        saving: 'Sparar filer...',
        saving_1: 'Sparar fil...',
        selectFiles: 'Välj filer',
        selectFiles_0: 'Välj fil',
        downloadFailed: 'Nedladdning misslyckades',
        downloadSuccess: 'Filen har laddats ner',
    },
    footer: {
        contactIntro: 'Vi hjälper dig',
        email: {
            prefix: 'E-post: ',
            text: 'Skriv till oss',
            url: {
                default: 'mailto:kundeogmiljosenter@klpeiendom.no',
                sv: 'mailto:info@klpfastigheter.se',
                da: 'mailto:kbh@klp.no',
            },
        },
        openingHours: {
            default: 'Bemannad dygnet runt',
            sv: 'Bemannad dygnet runt',
            da: 'Bemannat under kontorstider',
        },
        phone: {
            prefix: '24-timmars telefon: ',
            default: {
                title: '23 08 08 14',
                url: 'tel:+4723080814',
            },
            sv: {
                title: '08-657 77 56',
                url: 'tel:+4686577756',
            },
            da: {
                title: '(+45) 70 26 26 61',
                url: 'tel:+4570262661',
            },
        },
        privacy: {
            description: 'Behandling av personuppgifter',
            url: {
                default:
                    'https://www.klpeiendom.no/oslo/om-klp-eiendom/personvern',
                sv: 'https://www.klpfastigheter.se/stockholm/om-oss/personuppgifter',
                da: 'https://www.klpejendomme.dk/kobenhavn/om-os/persondatapolitik',
            },
        },
        newSak: {
            text: 'Registrera ett nytt ärende',
            link: 'https://mittleieforhold.klpeiendom.no/sak/add',
        },
    },
    frontPage: {
        accountSettings: 'Kontoinställningar',
        buildings: 'Fastigheten',
        buildingsLink: 'Mina fastigheter',
        contract: 'Avtal',
        contractManagement: {
            subtitle: 'Förhandla ett nytt avtal?',
            contractNegotiation: 'Avtalsförhandling',
        },
        dxboProject: 'Beslutsportal',
        frontpage: 'Startsida',
        invoice: {
            title: 'Fakturor',
            invoiceLink: 'Mina fakturor',
            sumOutstanding: 'Utestående belopp: ',
            outstandingInvoiceCount: 'Fakturor {{outstandingInvoiceCount}} stk',
            outstanding: 'Utestående',
        },
        messages: 'Anslagstavla',
        messagesLink: 'Se alla meddelanden',
        mytasksLink: 'Ärendeöversikt',
        errorReporting: 'Felanmälan',
        newsFeed: {
            title: 'Senaste från KLP Eiendom:',
            linkText: 'Se allt från KLP Eiendom på LinkedIn',
        },
        twoFactorAlertText: 'Tvåfaktorsautentisering tillgänglig',
        boldTwoFactorAlertText: ' - Aktivera i kontoinställningar!',
        welcome: {
            mittleieforhold: 'Välkommen till Min lokal',
            forvalter: 'Välkommen till dashbord för fastigheter',
            yourAdminDashboard:
                'Välkommen till  ditt Fastighet dashbord{{name}}',
        },
        miljo: {
            title: 'Miljö',
        },
        sustainability: {
            title: 'Hållbarhet',
        },
        miljoprofil: {
            title: 'Byggnadens miljöprofil',
        },
    },
    editor: {
        paragraph: 'Stycke',
        heading1: 'Rubrik 1',
        heading2: 'Rubrik 2',
        heading3: 'Rubrik 3',
        heading4: 'Rubrik 4',
        heading5: 'Rubrik 5',
        heading6: 'Rubrik 6',
        horizontalRule: 'Horisontell linje',
        insertTable: 'Infoga tabell',
        loadingEditor: 'Laddar editor...',
        addColumnBefore: 'Ny kolumn före',
        addColumnAfter: 'Ny kolumn efter',
        deleteColumn: 'Radera kolumn',
        addRowBefore: 'Ny rad före',
        addRowAfter: 'Ny rad efter',
        deleteRow: 'Radera rad',
        deleteTable: 'Radera tabell',
    },
    general: {
        adminContent: 'Detta är endast synligt för administratörsanvändare',
        backToTop: 'Tillbaka till toppen',
        by: 'av',
        cancel: 'Avbryt',
        clear: 'Tömma',
        clearList: 'Tömma listan',
        clearSelection: 'Ta bort valet',
        close: 'Stänga',
        confirm: 'Ja',
        days: 'dagar',
        days_0: 'dag',
        decline: 'Nej',
        delete: 'Radera',
        details: 'Detaljer',
        download: 'Ladda ner',
        draft: 'Utkast',
        edit: 'Redigera',
        emptyList: 'Listan är tom',
        successfulOperation: 'Åtgärden utfördes framgångsrikt.',
        error: 'Fel',
        errorMessage: 'Ett fel har inträffat. \n Försök igen senare.',
        expired: 'Utgått',
        goBack: 'Gå tillbaka',
        goBackToFrontpage: 'Gå tillbaka till förstasidan',
        loading: 'Laddar...',
        deleting: 'Raderar...',
        menu: 'Meny',
        month: 'Månad',
        month_0: 'Jan',
        month_1: 'Feb',
        month_2: 'Mar',
        month_3: 'Apr',
        month_4: 'Maj',
        month_5: 'Jun',
        month_6: 'Jul',
        month_7: 'Aug',
        month_8: 'Sep',
        month_9: 'Okt',
        month_10: 'Nov',
        month_11: 'Dec',
        // tslint:disable-next-line: max-line-length
        noIe: 'Vi är ledsna, men den här funktionen stöds inte i Internet Explorer. Vi rekommenderar att du använder Google Chrome eller webbläsaren Mozilla Firefox.',
        of: 'av',
        open: 'Öppna',
        outdatedBrowser: {
            description:
                'Kära användare! Din webbläsare är föråldrad och vissa funktioner kan vara felaktiga. Vi rekommenderar att du använder Google Chrome eller webbläsaren Mozilla Firefox.',
            title: 'Föråldrad webbläsare',
        },
        pageNotFound: 'Hittade inte sidan',
        preview: 'Förhandsvisning',
        previewDownload: 'Förhandsvisning / Ladda ner',
        publish: 'Publicera',
        readMore: 'Läs mer',
        reload: 'Ladda om',
        reset: 'Återställa',
        save: 'Spara',
        saveAsDraft: 'Spara som utkast',
        saved: 'Lagringen lyckades',
        saving: 'Sparar...',
        show: 'vis',
        showAll: 'Visa alla',
        submit: 'Skicka in',
        sum: 'Summa',
        updating: 'Uppdaterar...',
        wrote: 'skrev',
    },
    kontrakt: {
        agreements: 'avtal',
        agreements_1: 'avtal',
        agreementRows: 'rader',
        agreementRows_1: 'rad',
        antall: 'Storlek',
        antenne: 'Antenn',
        'annet uten fellesar': 'Övrig utan gemensam area',
        arkiv: 'Arkiv',
        arligEiendomskatt: 'Årlig fastighetsskatt',
        arligFellesKostnad: 'Årlig hyrestillegg',
        arligLeie: 'Årlig hyra',
        bod: 'skjul',
        bolig: 'Bostad',
        butikk: 'Affär',
        'bygg felles': 'gemensam byggnad',
        coworking: 'Coworking',
        energiForbrukPrM2: 'Energiförbrukning per m²',
        errorContractNotFound: {
            description: 'Det finns inga avtal för denna fastigheten.',
            title: 'Inga avtal hittades.',
        },
        errorDownload: {
            description: 'Något gick fel när avtal laddades.',
            title: 'Något gick fel när avtal laddades.',
        },
        felles: 'Gemensam',
        felleskostnaderPrM2: 'Gemensamma kostnader pr m²',
        festetomter: 'Festetomter',
        forretning: 'Företag',
        'forretning uten fel': 'Företag utan gemensam area',
        fra: 'Från',
        garasje: 'Garage',
        'garasje uten felles': 'Garage utan gemensam area',
        gyldigFra: 'Giltig från',
        gyldigTil: 'Giltig till',
        hotell: 'Hotell',
        'kantine areal': 'Matsalsarea',
        kantine: 'Matsal',
        kontor: 'Kontor',
        kontrakt: 'Avtal',
        kontraktAgreements: 'Avtal',
        kontraktAgreementsActive: 'Aktiva avtal',
        kontraktAgreementsInfobox:
            'Denna sida visar endast aktiva avtal. Fullständig översikt och nedladdningar finns i ',
        kontraktFra: 'Avtal från',
        kontraktNummer: 'Avtalsnummer',
        kontraktsdato: 'Avtalsdatum',
        kontraktsnummer: 'Avtalsnummer',
        kontraktTil: 'Avtal till',
        kontraktGaranti: 'Garanti',
        kostPrPplassPrAr: 'Kostnad per p-plats och år',
        lager: 'Lager',
        'lager uten fellesar': 'Lager uten fellesar',
        m2: 'm²',
        unknownFileName: 'okänt filnamn',
        navn: 'Namn',
        other: 'Övrig',
        parkering: 'Parkering',
        pcs: 'stk.',
        pris: 'Pris',
        prisPerAar: 'Årspris',
        perAar: '/år',
        perM2: '/m²',
        perStk: '/stk',
        pricePerUnit: 'Enhetspris',
        reklameplass: 'Reklamplats',
        relatedFiles: 'Relaterade filer',
        showFiles: 'Visa filer',
        restaurant: 'Restaurang',
        servering: 'Servering',
        teknisk: 'Teknisk',
        'teknisk uten felles': 'Teknisk utan gemensam area',
        til: 'Till',
        fristOppsigelseLeietaker: 'Uppsägningsdatum',
        tomt: 'Tomt',
        totaltAreal: 'Totalarea',
        'trening uten felles': 'Träning utan gemensam area',
        verksted: 'Verkstad',
        undervisning: 'Undervisning',
        uteservering: 'Uteservering',
    },
    languageName: 'Svensk',
    listUsers: {
        adminUserExplanation:
            'Adminanvändare har full tillgång till all data. Endast KLP-användare kan vara adminanvändare.',
        notRegisteredInSuperOfficeWarning: {
            description:
                'För att du ska kunna se eller registrera användare för denna kund måste kunden först vara registrerad i SuperOffice',
            superOfficeButtonText: 'Öppna SuperOffice',
            title: 'Denna kund är inte registrerad i SuperOffice',
        },
        superUserExplanation:
            'Superanvändare har tillgång till avtal och fakturor. OBS! Kunden kan bestämma sig för att ge superanvändare åtkomst till andra användare i organisationen.',
        superUserExplanationForUser:
            'Superanvändare har tillgång till avtal och fakturor. Du kan bestämma dig för att ge superanvändaråtkomst till andra användare i din organisation.',
        title: 'Användare',
        usersForCustomer: 'Användare för {{customer}}',
    },
    message: {
        actions: {
            Deleted: 'Radera',
            Draft: 'Utkast',
            Expired: 'Ange som utgått',
            Published: 'Publicera',
            WillPublish: 'Ange publicering',
            sendCopyToMe: 'Skicka e-postmeddelande till mig',
        },
        action: 'Handling',
        addMessage: 'Nytt meddelande',
        allMessages: 'Alla meddelanden',
        backButton: 'Tillbaka till meddelandeöversikten',
        download: 'Ladda ner meddelande',
        category: {
            helperText: 'Välj meddelandetyp',
            name: 'Type',
        },
        categoryType: {
            Alert: 'Kritisk',
            Info: 'Info',
            Warning: 'Varsel',
        },
        channel: {
            confirmEmail:
                'Alla mottagare kommer att få ett e-postmeddelande. Vill du skicka den?',
            email: 'Skicka som e-post',
            infoText: 'E-postmeddelandet skickas under natten.',
            yes: 'Ja, skicka',
            notificationSent: 'Meddelande skickat till mottagare {{timeSent}}',
            sendTonight: 'Skicka ikväll/natten',
            sendImmediately: 'Skicka omedelbart',
        },
        content: {
            helperText: 'Skriv in ditt meddelande',
            name: 'Meddelande',
        },
        dialog: {
            Deleted: {
                action: 'Ja, radera meddelandet',
                description: 'Vill du radera meddelandet?',
                title: 'Radera meddelandet',
            },
            Draft: {
                action: 'Ja, ange som utkast',
                description: 'Vill du ändra status för meddelandeutkastet?',
                title: 'Ange som utkast',
            },
            Expired: {
                action: 'Ja, ange som utgånget',
                description:
                    'Vill du ändra status för meddelandet till utgånget?',
                title: 'Utgått meddelande',
            },
            Published: {
                action: 'Ja, publicera',
                description: 'Vill du publicera meddelandet?',
                title: 'Publicera meddelandet',
            },
        },
        editMessage: 'Redigera meddelande',
        errorNoMessagesFound: {
            description: 'Du har inga meddelanden just nu.',
            title: 'Du har inga meddelanden just nu.',
        },
        expiresAt: {
            helperText: 'Välj utgångsdatum eller lämna fältet tomt',
            name: 'Utgångsdatum',
        },
        importantMessages: 'Viktiga meddelanden',
        isPinned: {
            helperText: 'Du kan markera meddelandet i nyhetsflödet',
            name: 'Pin meddelandet',
        },
        messageDocuments: {
            helperText:
                'Du kan välja filer för radering eller ladda upp fler filer',
            name: 'Ritningar',
        },
        messageImages: {
            helperText:
                'Du kan välja bilder för radering eller ladda upp fler bilder',
            name: 'Bilder',
        },
        messagePinned: 'Detta meddelande är framhävd',
        messagesFor: 'Meddelanden för {{kundeName}} ({{kundeNummer}})',
        messageStatus: 'Status',
        myMessages: 'Mina meddelanden',
        publishAt: {
            helperText: 'Välj publiceringsdatum',
            name: 'Publiceringsdatum',
        },
        published: 'Publicerad',
        readMore: 'Läs hela ärendet',
        seeAll: 'Läs alla meddelanden',
        status: {
            Deleted: 'Raderade',
            Draft: 'Utkast',
            Expired: 'Utgånget',
            Published: 'Publicerad',
            WillPublish: 'Ska publiceras',
        },
        title: {
            helperText: 'Skriv inn titeln',
            name: 'Tittel',
        },
        updated: 'Uppdatert',
        // deprecated
        uploadedFiles: {
            helperText: 'Du kan markere filer för sletting',
            name: 'Opplastede filer',
        },
        // deprecated
        uploadFiles: {
            helperText: 'Välj nya filer som ska lastas upp vid lagring',
            name: 'Nya filer',
        },
        noMessages: 'Ingen melding funnen.',
    },
    registerUser: {
        'A user with the provided email address already exists': {
            description: 'Användaren med den här e-postadressen finns redan.',
            title: 'Fel uppstod under registrering av användaren.',
        },
        back: 'Tillbaka till användarna',
        disabledTooltip:
            'Knappen är inaktiverad eftersom det inte har valts om ett välkomstmeddelande ska skickas eller inte.',
        email: 'E-post',
        firstName: 'Förnamn',
        generalError: {
            description:
                'Registrering felet. Försök igen senare eller ta kontakt med oss så hjälper vi deg.',
            title: 'Fel uppstod under registrering av användaren.',
        },
        lastName: 'Efternamn',
        registerNew: 'Registrera ny användare',
        registeringUser: 'Registrerar användare...',
        successNotification: 'Registrering av användaren var vellykket.',
        title: 'Registrera användare för {{customer}}',
        roles: {
            title: 'Roller',
            superUserCheckBox:
                'Ska ha tillgång till avtal och fakturor (Superanvändare)',
        },
        other: {
            title: 'Övrig',
            velkomstmelding: 'Ska ett välkomstmeddelande skickas?',
            yesButton: 'Ja',
            noButton: 'Nej',
        },
    },
    sak: {
        actions: {
            Active: 'Öppet ärende',
            Closed: 'Stäng ärende',
            Deleted: 'Radera ärende',
            Merged: 'Slå samman',
            Postponed: 'Skjut upp ärende',
        },
        addSak: 'Nytt ärende',
        archivedTasksFor:
            'Arkiverade ärenden för {{kundeName}} ({{kundeNummer}})',
        backButton: 'Tillbaka till ärendeöversikten',
        confirmation: {
            title: 'Förfrågan registrerad',
            message:
                'Din förfrågan har registrerats. Vi svarar på ditt ärende så snart som möjligt.',
        },
        buildingcategory: {
            helperText: 'Välj fastighetskategori',
            name: 'Fastighetskategori',
        },
        category: {
            helperText: 'Välj kategori',
            name: 'Kategori',
        },
        created: 'Skapandedatum',
        dialog: {
            Active: {
                action: 'Ja öppna',
                description: 'Vill du öppna ärendet?',
                title: 'Öppna ärendet',
            },
            Closed: {
                action: 'Ja, stäng',
                description: 'Vill du stänga ärendet?',
                title: 'Stäng ärendet',
            },
        },
        emne: 'Ämne',
        email: 'E-post',
        emailCopyRecipient: 'Kopia till mottagare:',
        errorDownload: {
            description: 'Något gick fel vid laddning av ärendet.',
            title: 'Något gick fel vid laddning av ärendet.',
        },
        errorNotFound: {
            title: 'Inga öppna ärenden hittades.',
        },
        noTasks: 'Inga ärenden hittades.',
        goBackToSaker: 'Återgå till listan över ärenden',
        lukketDato: 'Stängt datum',
        melding: 'Meddelande',
        meldinger: {
            melding: {
                helperText: 'Skriv ditt svar',
                name: 'Svar',
            },
            noMoreMessages: 'Inga fler meddelanden.',
            sendSvar: 'Skicka svar',
        },
        myArchivedTasks: 'Mina arkiverade ärenden',
        myTasks: 'Mina ärenden',
        openArchive: 'Visa ärendearkiv',
        openSakList: 'Visa ärendeöversikt',
        opprettetAv: 'Skapad av',
        sakDocuments: {
            helperText:
                'Du kan välja filer för radering eller ladda upp fler filer',
            name: 'Ritningar',
        },
        saksnummer: 'Ärendenummer',
        source: 'Källa',
        sourceDalux: 'Dalux',
        sakImages: {
            helperText:
                'Du kan välja bilder för radering eller ladda upp fler bilder',
            name: 'Bilder',
        },
        sakLukketDato: 'Ärendet stängd den {{lukketDato}}',
        sakskategori: {
            Administration: 'Administration',
            Sale: 'Försäljning',
            Support: 'Support',
            title: 'Kategori',
        },
        saksMelding: {
            title: '{{author}} skrev {{date}:',
        },
        sakStatus: {
            Aktiv: 'Aktiv',
            Avsluttet: 'Avslutad',
            Sammenslått: 'Sammanslagna',
            Slettet: 'Raderad',
            Unknown: 'Okänd',
            Utsatt: 'Utsatt',
            'Venter på 3dje part': 'Väntar på tredje part',
            'Venter på kunde': 'Väntar  på kund',
        },
        sakStatusSummary: {
            EjPaborjad: 'Ej påbörjad',
            Utskriven: 'Utskriven',
            Utringd: 'Utringd',
            Kvitterad: 'Kvitterad',
            Aktiv: 'Aktiva',
            Aktiv_1: 'Aktiv',
            Avsluttet: 'Avslutade',
            Avsluttet_1: 'Avslutad',
            Sammenslått: 'Sammanslagna',
            Sammenslått_1: 'Sammanslagna',
            Slettet: 'Raderade',
            Slettet_1: 'Raderad',
            Unknown: 'Okända',
            Unknown_1: 'Okänd',
            Utsatt: 'Utsatte',
            Utsatt_1: 'Utsatt',
            'Venter på 3dje part': 'Väntar på tredje part',
            'Venter på 3dje part_1': 'Väntar på tredje part',
            'Venter på kunde': 'Väntar  på kund',
            'Venter på kunde_1': 'Väntar  på kund',
        },
        savingError: 'Ett fel uppstod när ärendet skulle sparas',
        savingSuccess: 'Lagrad',
        searchSak: 'Sök på ärenden',
        showAll: 'Visa alla meddelanden',
        status: 'Status',
        subcategory: {
            helperText: 'Välj underkategori',
            name: 'Underkategori',
        },
        summarytitle: 'Senaste ärenden',
        supportcategory: {
            helperText: 'Välj supportkategori',
            name: 'Supportkategori',
        },
        tasksFor: 'Ärende för {{kundeName}} ({{kundeNummer}})',
        vedlegg: {
            title: 'Bilagor',
        },
    },
    superOffice: {
        issue: {
            new: 'Registrera nytt ärende',
            status: {
                temporary: 'temporary',
                todo: 'todo',
            },
            title: 'Senaste ärende',
        },
        langCode: 'sv',
        mytasks: 'Mina ärenden',
        noaccess: 'Du har inte tillgång till SuperOffice',
        opening: 'Öppnar SuperOffice...',
    },
    supportForm: {
        attachments: {
            attachments: 'Ladda upp bilagor',
            attachmentsHelperText: 'Välj filerna att ladda upp',
            title: 'Bilagor',
        },
        company: {
            companyName: 'Företagets juridiska namn',
            companyNameHelperText: 'Ange företagets juridiska namn',
            orgNumber: 'Organisationsnummer',
            orgNumberHelperText: 'Ange organisationsnummer',
        },
        contact: 'Kontakt',
        description:
            'Förklaring till varför vi hjälper våra hyresgäster. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur massa libero, eleifend eu erat sed, consequat malesuada lacus. Suspendisse vitae neque ut lacus ultricies blandit. Pellentesque elementum, nulla quis accumsan pellentesque, enim metus sagittis justo, eget pellentesque sapien tortor at odio. Nam nulla orci, pharetra vitae dignissim in, sagittis sit amet neque. Sed sed massa eget arcu scelerisque dapibus. Suspendisse bibendum erat quis lorem maximus dignissim. Vivamus risus tortor, interdum vehicula molestie ut, tempor et felis. Vestibulum aliquam interdum lectus, et interdum lorem gravida eget. Vivamus vulputate placerat nulla, ut consectetur ante rhoncus quis. Fusce sem enim, efficitur vitae ante in, sagittis vulputate dolor. Vivamus nec massa sem. Proin in tincidunt tellus. Nulla eget leo quis nisi cursus congue.',
        economy: 'Statens ersättningssystem',
        email: {
            email: 'E-post',
            emailHelperText: 'Skriv inn din e-post',
        },
        governmentSupport: {
            amount: 'Summa',
            amountHelperText: 'Ange summan här',
            caseNumber: 'Ärendenummer',
            caseNumberHelperText: 'Skriv inn ärendenummeret',
            governmentSupport: 'Har du fått stöd från staten?',
            governmentSupportExplanation: 'Om inte, varför inte?',
            governmentSupportExplanationHelperText:
                'Berätta gärna varför du inte fick stödet',
            governmentSupportHelperText: 'Välj om du har fått stöd från staten',
            month: 'Månad',
        },
        invoice2020Q3: {
            invoiceNumber: 'Fakturanummer Q3 2020',
            invoiceNumberHelperText: 'Skriv inn fakturanummeret för Q3 2020',
        },
        kundeNummer: {
            clientNumber: 'Kundnummer hos KLP',
            clientNumberHelperText: 'Skriv inn kundnummeret hos KLP',
        },
        leietakerinformasjon: 'Hyresgästinformation',
        other: {
            klpSupportReasonHelperText: 'Skriv din förklaring här',
            klpSupportReasonTitle:
                'Beskriv varför du behöver stöd efter att det statliga systemet upphör',
            klpSupportReasonTitleShort: 'Logisk grund',
            title: 'Övrig',
        },
        personApplying: {
            personName: 'Namn på ärende',
            personNameHelperText: 'Skriv inn ditt namn',
        },
        phoneNumber: {
            phoneNumber: 'Telefonnummer',
            phoneNumberHelperText: 'Skriv inn telefonnummer',
        },
        registerForm: 'Registrera ansökan',
        revenue: {
            amount: 'Summa',
            amountHelperText: 'Ange summan här',
            month: 'Månad',
            revenue2019: '2019',
            revenue2020: '2020',
            title: 'Omsättningssiffror',
        },
        shoppingCenter: {
            shoppingCenterHelperText: 'Välj centret',
            shoppingCenterName: 'Centertillhörighet',
        },
        store: {
            storeName: 'Affärsnamn',
            storeNameHelperText: 'Ange butikens namn',
        },
        support: 'Stödsystem',
        title: 'Ansökan om stöd',
    },
    tables: {
        labelRowsPerPage: 'Rader per sida:',
    },
    user: {
        myAccount: 'Mitt konto',
    },
    userSearch: {
        activeUsers: 'Aktiva användare',
        addCustomer: 'Lägg till',
        addCustomerError: 'Ett fel uppstod när kunder skulle uppdateras.',
        addCustomerSuccess: 'La till kund {{customer}}',
        addCustomerTitle: 'Lägg till kund',
        grantAdminError:
            'Kunde inte ge administratörsbehörigheter till {{email}}.',
        grantAdminQuestion:
            'Vill du ge administratörsrättigheter till {{email}}?',
        grantAdminSuccess: 'Bevilja administratörsbehörigheter till {{email}}.',
        grantSuperUserError:
            'Det gick inte att ge superanvändarrättigheter till {{email}}.',
        grantSuperUserQuestion:
            'Vill du ge superanvändarrättigheter till {{email}}?',
        grantSuperUserSuccess:
            'Lade till superanvändarrättigheter till {{email}}.',
        grantSuperUserTooltip:
            'Ger eller tar bort tillgång till avtal och fakturor',
        inActiveUsers: 'Inaktiva användare',
        invitationNotSent: 'Inte skickat',
        invitationSent: 'Inbjudan skickad',
        invite: 'Inbjuda',
        inviteActivateUser: 'Bjud in/aktivera användare',
        inviteUserError:
            'Ett fel uppstod när inbjudan skickades till {{email}}.',
        inviteUserQuestion: 'Vill du skicka en inbjudan till {{email}}?',
        inviteUserSuccess: 'Det gick bra att skicka inbjudan till {{email}}.',
        refreshingList: 'Uppdaterar listan...',
        removeCustomerError: 'Ett fel uppstod när användaren uppdaterades.',
        removeCustomerQuestion:
            'Vill du ta bort kundåtkomst {{customer}} för {{email}}?',
        removeCustomerSuccess: 'Tog bort kundåtkomst till {{customer}}',
        removeUserSuccess: 'Tog bort tillgång for {{user}}',
        removeUserError: 'Det gick inte att ta bort användaren',
        removeUserTitle: 'Ta bort bruker',
        removeUserQuestion: 'Vill du ta bort bruker {{email}}?',
        remove: 'Radera',
        removeCustomerTitle: 'Ta bort kundåtkomst',
        revokeAdminError:
            'Det gick inte att ta bort administratörsbehörigheter för {{email}}.',
        revokeAdminQuestion:
            'Vill du ta bort administratörsbehörigheter för {{email}}?',
        revokeAdminSuccess:
            'Tog bort administratörsbehörigheter för {{email}}.',
        revokeSuperUserError:
            'Det gick inte att ta bort superanvändarrättigheter för {{email}}.',
        revokeSuperUserQuestion:
            'Vill du ta bort superanvändarrättigheter för {{email}}?',
        revokeSuperUserSuccess:
            'Superanvändarrättigheter har tagits bort för {{email}}.',
        searchPlaceholder: 'Sök',
        searchResults: 'Sökresultat ({{count}} hits)',
        searchTitle: 'Sök efter användare',
        send: 'Skicka',
        sendNewWelcomeMessage: 'Skicka nytt välkomstmeddelande',
        sendWelcomeMessageError:
            'Ett fel uppstod när välkomstmeddelandet skickades till {{email}}.',
        sendWelcomeMessageQuestion:
            'Vill du skicka ett välkomstmeddelande till {{email}}?',
        sendWelcomeMessageSuccess:
            'Skickat välkomstmeddelande till {{email}} lyckades.',
        userCustomers: 'Kunder',
        userEmail: 'E-post',
        userFirstName: 'Förnamn',
        userIsAdmin: 'Adminanvändare',
        userIsSuperUser: 'Superanvändare',
        userIsOrdinaryUser: 'Vanlig användare',
        userLastName: 'Efternamn',
        welcomeMessageSent: 'Välkomstmeddelande skickat',
        grantSuperUser: 'Ge superanvändar tillgång',
        grantAdminUser: 'Ge adminanvändar tillgång',
        revokeSuperUser: 'Ta bort superanvändar tillgång',
        revokeAdminUser: 'Ta bort adminanvändar tillgång',
        role: 'Roll',
        action: 'Handling',
    },
    validator: {
        email: 'Giltig e-postadress krävs!',
        required: 'Fältet är obligatoriskt!',
    },
};
